import type { EmptyStateProps } from './EmptyState';
import { EmptyState } from './EmptyState';
import { EmptyStateAction } from './EmptyStateAction';

type ErrorStateProps = Omit<EmptyStateProps, 'type'>;

const ErrorStateBase = (props: ErrorStateProps) => (
    <EmptyState {...props} type="error" />
);

export const ErrorState = Object.assign(ErrorStateBase, {
    Action: EmptyStateAction,
});
